export default __webpack_public_path__ + "static/media/TomMooreCharityInvestigate.10122e75.jpg";